import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import MessagesContext from '../../contexts/messagesContext';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import Chart from './Chart';
import StatisticsHeader from './StatisticsHeader';
import * as type from '../../redux/Statistics/StatisticsType';
import { useSelector } from 'react-redux';

const styles = makeStyles({
    container: {
        minHeight: '300px',
        background: '#fff',
        borderRadius: '8px',
        padding: '24px'
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '350px'
    }
});
const FormStatistics = () => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const loadingSelector = createLoadingSelector(type.GET_FORM_STATISTICS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    return (
        <>
            <div className={classes.container}>
                <StatisticsHeader title={messages.newForms} isFormStatistics />

                {isLoading ? (
                    <div className={classes.loadingContainer}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Chart isFormStatistics />
                )}
            </div>
        </>
    );
};

export default FormStatistics;
